import { Component, Input, inject } from '@angular/core';
import { AdminService } from '../../../admin/admin.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuditItem } from '../../../models/admin-models';
import { NgxLoadingModule } from 'ngx-loading';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { GridModule } from '@progress/kendo-angular-grid';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-audit-management',
  templateUrl: './audit-management.component.html',
  styleUrl: './audit-management.component.scss',
  imports: [
    NgxLoadingModule,
    MatInputModule,
    MatDatepickerModule,
    MatIconModule,
    MatButtonModule,
    GridModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class AuditManagementComponent {
  private admnSvc = inject(AdminService);
  private snacky = inject(MatSnackBar);

  @Input() baseUrl: string;
  startDate: string | Date | null = null;
  endDate: string | Date | null = null;
  type: string = '';
  limit: number | string | null = null;
  auditData: AuditItem[] = [];
  loading = false;
  gridColumns: string[] = [];
  selectedIds: number[] = [];

  getAudits() {
    this.loading = true;
    const getQuery = {
      solution: 'rb',
      startDate: this.startDate
        ? new Date(this.startDate).toLocaleDateString()
        : null,
      endDate: this.endDate
        ? new Date(this.endDate).toLocaleDateString()
        : null,
      type: this.type,
      limit: this.limit,
    };
    this.admnSvc.getAuditStatus(getQuery).subscribe(res => {
      this.auditData = res;
      const uniqueKeys = new Set<string>();
      this.auditData.forEach(dataItem => {
        Object.keys(dataItem).forEach(key => {
          uniqueKeys.add(key);
        });
      });
      this.gridColumns = [...uniqueKeys];
      this.loading = false;
    });
  }

  retryAudits() {
    if (!this.selectedIds.length) {
      this.snacky.open('No audits selected for retry.', 'Close', {
        duration: 5000,
      });
      return;
    }
    this.selectedIds = this.selectedIds.map(stringId => Number(stringId));
    this.loading = true;
    const postQuery = {
      solution: 'rb',
      payload: { auditIds: this.selectedIds },
    };
    this.admnSvc.retryAudit(postQuery).subscribe({
      next: res => {
        this.selectedIds = [];
        const retryCount = res?.data || 0;
        this.snacky.open(`Success! ${retryCount} record(s) retried.`, 'Close', {
          duration: 5000,
        });
        this.getAudits();
      },
      error: error => {
        console.error('Error retrying audits:', error);
        this.selectedIds = [];
        this.loading = false;
        const errorMessage = error?.message || 'There was an unexpected error.';
        this.snacky.open(`Error! ${errorMessage}`, 'Close', { duration: 5000 });
      },
    });
  }

  deleteAudits() {
    if (!this.selectedIds.length) {
      this.snacky.open('No audits selected for deletion.', 'Close', {
        duration: 5000,
      });
      return;
    }
    this.selectedIds = this.selectedIds.map(stringId => Number(stringId));
    this.loading = true;
    const postQuery = {
      solution: 'rb',
      payload: { auditIds: this.selectedIds },
    };
    this.admnSvc.deleteAudit(postQuery).subscribe({
      next: res => {
        this.auditData = this.auditData.filter(
          item => !this.selectedIds.includes(Number(item.id))
        );
        this.selectedIds = [];
        this.loading = false;
        const deletedCount = res?.data || 0;
        this.snacky.open(
          `Success! ${deletedCount} record(s) deleted.`,
          'Close',
          { duration: 5000 }
        );
      },
      error: error => {
        console.error('Error deleting audits:', error);
        this.selectedIds = [];
        this.loading = false;
        const errorMessage = error?.message || 'There was an unexpected error.';
        this.snacky.open(`Error! ${errorMessage}`, 'Close', { duration: 5000 });
      },
    });
  }
}
